import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  Row,
  Col,
  Card,
  Spinner,
  Alert,
  FloatingLabel,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import validator from "validator";
import { vasthuUrl } from "../component/Api";
import { UseVasthu } from "../context/vasthu";
import PaymentProcess from "../component/PaymentProcess";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../component/HelmetSeo";

const CustomerPlotForm = () => {
  const { addPlotRecId, lagnaList, facingList } = UseVasthu();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = localStorage.getItem("i18nextLng");
  const langCode = window.localStorage.getItem("i18nextLng");
  const userId = window.sessionStorage.getItem("userId");
  const token = window.sessionStorage.getItem("token");
  const [pOwner, setPOwner] = useState("");
  const [pArea, setPArea] = useState("");
  const [pfacing, setPfacing] = useState("");
  const [plagna, setPlagna] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const showPaytm = false;
  const paymentCredentials = {
    txnToken: "",
    orderId: "",
    amount: 0,
    offerId: 0,
    userId: "",
  };

  const alert = (msg) => {
    setMessage(msg);
    setTimeout(() => {
      setMessage("");
    }, 4000);
  };

  const handlePsumbitFree = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      if (
        validator.isNumeric(pArea, { no_symbols: true }) &&
        !validator.isEmpty(pArea) &&
        !validator.isEmpty(pOwner) &&
        !validator.isEmpty(pfacing) &&
        !validator.isEmpty(plagna) &&
        !validator.isEmpty(token)
      ) {
        try {
          console.log("no subscription - please proceed with pay");
          const res = await vasthuUrl.post(
            `saveplot`,
            {
              ownerName: pOwner,
              plotArea: pArea,
              uuid: userId,
              directionId: Number(pfacing),
              lagnaId: Number(plagna),
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          addPlotRecId(res.data.plotId);
          console.log("after save", res.data);
          setLoading(false);
          setPOwner("");
          setPArea("");
          setPfacing("");
          setPlagna("");

          // setLoading(true);
          console.log("plotId", res.data.plotId, typeof res.data.plotId);

          // try{

          // setTimeout(() => {
          vasthuUrl
            .get(`/validateplotresult/${res.data.plotId}/${langCode}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => {
              setLoading(false);
              console.log("Plot record screen", res.data);
              navigate("/plotvalidatefree", {
                state: res.data,
              });
            });
          // }, 3000);
        } catch (error) {
          console.log("error from trying subscription list " + error);
        }
      } else {
        alert("GIVEN INPUT IS INVALID");
        setLoading(false);
      }
    } catch (e) {
      alert("CHECK INTERNET CONNECTION");
      setLoading(false);
      // console.log("SERVER ERROR", e);
    }
  };

  return (
    <div>
      <HelmetSeo
        title="Plot Vastu Guide for Home & Land Selection | Vasthuparam"
        name="description"
        content="Discover vastu tips for selecting the perfect plot. Learn how directions, shape, and surroundings affect positivity. Vastu guidance for land buying from Vasthuparam."
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/plotvasthu"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/plotvasthu"
      />

      <Row>
        <Col xl="3" lg="3" md="2" sm="1" />
        <Col xl="6" lg="6" md="8" sm="10">
          <Card className="p-2 m-1 mt-3 all_border">
            <Card.Header as="h5" className="all_background">
              <center>{t("USR.HOM.HD.VFP")}</center>
            </Card.Header>
            <Card.Body>
              <Form className="mt-2">
                {/* {message && (
                    <Card.Body className="text-center" style={{ color: "red" }}>
                      {message}
                    </Card.Body>
                  )} */}
                {message && (
                  <Alert variant="info" className="text-center">
                    {/* {message} */}
                    {t("USR.VFP.PLT.INVD.INP")}
                  </Alert>
                )}

                <Form.Floating className="mb-3">
                  <Form.Control
                    id="floatingPlotOwner"
                    type="text"
                    value={pOwner}
                    onChange={(e) => {
                      let input = e.target.value;
                      // Ensure only the first character is a letter
                      input = input.replace(/^([^A-Za-z])/, "");
                      // Allow only alphanumeric characters after the first character
                      input = input.replace(/[^A-Za-z0-9]/g, "");
                      setPOwner(input);
                    }}
                    placeholder={t("USR.VSH.RES.ACR.MSC.TBL.CLMN.NM")}
                    className="form_feild"
                  />
                  <label htmlFor="floatingPlotOwner">
                    {t("USR.VFP.INP.PO")}
                  </label>
                </Form.Floating>

                <Form.Floating className="mb-3">
                  <Form.Control
                    id="floatingPlotArea"
                    type="number"
                    min="0"
                    value={pArea}
                    onChange={(e) => setPArea(e.target.value)}
                    placeholder={t("USR.VFPR.TBL.CLMN.AR")}
                    className="form_feild"
                  />
                  <label htmlFor="floatingPlotArea">
                    {t("USR.VFP.INP.PA")}
                  </label>
                </Form.Floating>

                <FloatingLabel
                  className="mb-2"
                  controlId="formPlotFacing"
                  label={t("USR.VFP.DRP.LBL.PF")}
                >
                  <OverlayTrigger
                    placement="left"
                    overlay={
                      <Tooltip id="button-tooltip">
                        {t("USR.VSH.HFTAB.HF.HTXT")}
                      </Tooltip>
                    }
                  >
                    <Form.Select
                      aria-label={t("USR.VFP.DRP.LBL.PF")}
                      // style={{ fontSize: "1rem" }}
                      value={pfacing}
                      onChange={(e) => {
                        setPfacing(e.target.value);
                      }}
                      className="form_feild"
                    >
                      <option value="" className="opttion_hover">
                        {t("USR.VSH.HFTAB.HF.PH")}
                      </option>
                      {facingList.map((i, j) => (
                        <option key={j} value={i.id} className="opttion_hover">
                          {lang === "ta" ? (
                            <p>{i.ta_name}</p>
                          ) : lang === "hi" ? (
                            <p>{i.hi_name}</p>
                          ) : (
                            <p>{i.name}</p>
                          )}
                        </option>
                      ))}
                    </Form.Select>
                  </OverlayTrigger>
                </FloatingLabel>

                <FloatingLabel
                  className="mb-2"
                  controlId="formPlotLagna"
                  label={t("USR.VFP.DRP.LBL.LG")}
                >
                  <Form.Select
                    aria-label={t("USR.VFP.DRP.LBL.LG")}
                    style={{ fontSize: "1rem" }}
                    value={plagna}
                    onChange={(e) => {
                      setPlagna(e.target.value);
                    }}
                    className="form_feild"
                  >
                    <option value="">{t("USR.VFP.DRP.PH.LG")}</option>
                    {lagnaList.map((i, j) => (
                      <option key={j} value={i.id}>
                        {lang === "ta" ? (
                          <p>{i.ta_name}</p>
                        ) : lang === "hi" ? (
                          <p>{i.hi_name}</p>
                        ) : (
                          <p>{i.name}</p>
                        )}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>

                <Form.Group
                  className="d-grid gap-2 mt-2"
                  controlId="formSubmitBtn"
                >
                  <center>
                    {" "}
                    <h4 className="card-text">
                      {t("USR.FREE")} <s>99</s>
                    </h4>
                  </center>
                  {!loading ? (
                    <Col className="d-flex justify-content-center">
                      <Button
                        className="plot-submit all_btn mx-2 all_btn"
                        type="submit"
                        onClick={handlePsumbitFree}
                      >
                        {t("USR.VFP.PV.BTN.SMTPY")}
                      </Button>
                    </Col>
                  ) : (
                    <center>
                      <Spinner
                        animation="border"
                        role="status"
                        variant="warning"
                      />
                    </center>
                  )}
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Col>{" "}
        <Col xl="3" lg="3" md="2" sm="1" />
      </Row>

      {showPaytm && (
        <PaymentProcess
          txnToken={paymentCredentials.txnToken}
          orderId={paymentCredentials.orderId}
          amount={paymentCredentials.amount}
          offerId={paymentCredentials.offerId}
          userId={paymentCredentials.userId}
          navigate={navigate}
          screenName={`/plotvalidate`}
        />
      )}
    </div>
  );
};

export default CustomerPlotForm;
